export class Schedule {
    public startTime: string;
    public endTime: string;
    public intervalMinutes: number;
    public days: number[];

    constructor();
    constructor(json: any);
    constructor(startTime: string, endTime: string, intervalMinutes: number, days: number[]);
    constructor(startTimeOrJson?: any, endTime?: string, intervalMinutes?: number, days?: number[]) {
        if (startTimeOrJson) {
            if (endTime) {
                this.startTime = startTimeOrJson;
                this.endTime = endTime;
                this.intervalMinutes = intervalMinutes;
                this.days = days;
            } else {
                this.startTime = startTimeOrJson.startTime;
                this.endTime = startTimeOrJson.endTime;
                this.intervalMinutes = startTimeOrJson.intervalMinutes;
                this.days = startTimeOrJson.days;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/schedule.ts